import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const MONTHS_OPTS = ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"];
export const WHEEL_MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"];

const NOW = new Date();
export const CUR_YEAR = NOW.getFullYear();
export const CUR_MONTH = NOW.getMonth() + 1;
export const DEFAULT_FIN = { enabled: false, mode: "ytd", year: CUR_YEAR, from_month: 1, to_month: CUR_MONTH };
export const BOARD_ROLES = ["Styreleder", "Nestleder", "Styremedlem", "Varamedlem", "Daglig leder"];

export function initials(n = "") {
  return n.split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
}

export function MonthSelect({ label, testid, value, onChange }) {
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger data-testid={testid} className="mt-1.5"><SelectValue /></SelectTrigger>
        <SelectContent>
          {MONTHS_OPTS.map((m, i) => (<SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>))}
        </SelectContent>
      </Select>
    </div>
  );
}
